<template>
  <div class="maptable">

    <div class="main-wrap">
      <transition style="fade">
        <PreloaderOverlay v-if="$store.state.fetching.length > 0"></PreloaderOverlay>
      </transition>

      <ViewModeTable :showAttributes="[selectedAttribute]" :data="tableData" :dateRange="year"></ViewModeTable>
      <InfoOverlay
        class="infoOverlay"
        v-if="!selectedAttribute"
        :description="this.$Strings('mapChooseAttribute')"
      ></InfoOverlay>
    </div>

  </div><!-- /.worldmap -->
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

import PreloaderOverlay from '../shared/misc/PreloaderOverlay'
import ViewModeTable from './ViewModeTable'
import InfoOverlay from '../shared/misc/InfoOverlay'

import {EventBus} from '@/event-bus.js'

export default {
  name: 'worldmap',
  props: {},
  components: { PreloaderOverlay, ViewModeTable, InfoOverlay },
  data () {
    return {
      CancelToken: axios.CancelToken,
      cancel () {},
      data: []
    }
  },
  mounted () {
    EventBus.$emit('sidebar-nav', 'WorldMap')
    this.$store.state.viewMode = 'table'
    if (this.selectedAttribute) {
      this.loadData(() => {})
    }
  },
  computed: {
    viewmode () {
      return this.$store.state.viewMode
    },
    year () {
      return this.$store.state.yearSliderCurrent
    },
    regions () {
      let all = this.$store.state.rsc.all
      return all.regions
    },
    selectedAttribute () {
      return this.$store.getters['attributes/firstSelected']
    },
    tableData () {
      let result = []
      _.each(this.data, (row, i) => {
        if (
          row.ID_region && row.ID_region !== '' &&
          row.ID_subregion && row.ID_subregion !== ''
        ) {
          result[i] = row
        }
      })
      return _.sortBy(result, ['ID_country_name'])
    }
  },
  watch: {
    selectedAttribute () {
      if (this.data.length === 0) {
        this.loadData(() => {})
      }
    },
    year () {
      this.loadData(() => {})
    },
    viewmode () {
      if (this.viewmode === 'chart') {
        this.changeViewMode()
      }
    }
  },
  methods: {
    changeViewMode () {
      let attr = this.selectedAttribute
      let query = {}
      if (attr) {
        query.attr = ['["' + attr + '"]']
      }
      this.$router.push({ name: 'democracy-indices', query: query })
    },
    toggleInterval () {
      this.showConfidenceIntervals = !this.showConfidenceIntervals
    },
    loadData (callback) {
      this.$store.dispatch('startFetching', 'maptable')
      this.cancel()
      axios.all([this.fetchData()], {
        cancelToken: new this.CancelToken((c) => {
          this.cancel = c
        })
      })
        .then(axios.spread((response) => {
          this.$store.dispatch('stopFetching', 'maptable')
          this.data = response.data
          if (callback !== undefined) callback()
        }))
        .catch((error) => {
          this.$store.dispatch('stopFetching', 'maptable')
          if (!axios.isCancel(error)) {
            EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
            console.log(error)
          }
        })
    },
    fetchData () {
      return axios.get(process.env.API_URL + 'data?year1=' + this.year + '&year2=' + this.year)
    }
  }
}
</script>

<style lang="scss">
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/mixins/clearfix';

  .tablearea__header{
    @include clearfix()
  }
  .tablearea__header__title{
    float: left;
    margin-top: 0;
  }

  .tablearea__header__options{
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/MapTable.vue